import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/user/login/',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function getInfo() {
  return request({
    url: '/user/info/',
    method: 'post',
  })
}

export function logout() {
  return request({
    url: '/user/logout/',
    method: 'post'
  })
}

export function fetchList(data) {
  return request({
    url: '/user/admin/list/',
    method: 'post',
    data
  })
}

export function createAdmin(data) {
  return request({
    url: '/user/admin/register/',
    method: 'post',
    data
  })
}

export function updateAdmin(data) {
  return request({
    url: '/user/admin/update/',
    method: 'post',
    data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/user/admin/updateStatus/' + id + '/',
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/user/admin/delete/' + id + '/',
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/user/admin/role/' + id + '/',
    method: 'post'
  })
}

export function allocRole(data) {
  return request({
    url: '/user/admin/role/update/',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js